<div class="relative pt-5" *ngIf="menuData" [style.width.px]="config?.width">
    <div class="dropdown-content rounded-lg border border-gray-200 bg-white p-6 shadow-lg">
        <!-- Menu 1 -->
        <div class="dropdown-header mb-4" *ngIf="menuData.header">
            <h3 class="hu-dark:text-contrast-yellow text-primary-header mb-2">
                {{ menuData.header.title | translate | uppercase }}
            </h3>

            <div class="grid grid-cols-1 gap-4 md:grid-cols-2" *ngIf="menuData.header.items">
                <div class="header-item" *ngFor="let item of menuData.header.items">
                    <a class="font-medium text-primary" *ngIf="!item.isExternal" [routerLink]="item.path | localize">
                        {{ item.label | translate }}
                    </a>

                    <a class="font-medium text-primary" *ngIf="item.isExternal" [href]="item.path | translate">
                        {{ item.label | translate }}
                    </a>

                    <p class="hu-dark:text-contrast-yellow text-primary-header mt-1 text-sm" *ngIf="item.description">
                        {{ item.description | translate }}
                    </p>

                    <div
                        class="hu-dark:text-contrast-yellow mt-2 flex items-center text-sm font-semibold text-primary"
                        *ngIf="item.notice">
                        <mat-icon class="mr-1 text-sm">info</mat-icon>
                        {{ item.notice | translate }}
                    </div>
                </div>
            </div>
        </div>

        <hr
            class="custom-border-line mb-4 border-t-2 dark:!border-contrast-yellow dark:bg-contrast-yellow"
            *ngIf="menuData.header" />

        <div class="dropdown-main" [ngSwitch]="menuData.layout">
            <div class="space-y-4" *ngSwitchCase="'two-column'">
                <div class="dropdown-section" *ngFor="let section of menuData.sections">
                    <h3 class="hu-dark:text-contrast-yellow text-primary-header mb-3">
                        {{ section.title | translate | uppercase }}
                    </h3>
                    <div class="grid grid-cols-2 gap-8">
                        <div class="dropdown-item" *ngFor="let item of section.items">
                            <a
                                class="font-medium text-primary"
                                *ngIf="!item.isExternal"
                                [routerLink]="item.path | localize">
                                {{ item.label | translate }}
                            </a>

                            <a class="font-medium text-primary" *ngIf="item.isExternal" [href]="item.path | translate">
                                {{ item.label | translate }}
                            </a>
                            <p
                                class="hu-dark:text-contrast-yellow text-primary-header mt-1 whitespace-pre-line text-sm"
                                *ngIf="item.description">
                                {{ item.description | translate }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Menu 2 -->
            <div class="space-y-4" *ngSwitchCase="'stack'">
                <div class="dropdown-section" *ngFor="let section of menuData.sections">
                    <h3 class="hu-dark:text-contrast-yellow text-primary-header mb-3">
                        {{ section.title | translate | uppercase }}
                    </h3>
                    <div class="grid grid-cols-2 gap-8">
                        <div class="dropdown-item" *ngFor="let item of section.items">
                            <a
                                class="font-medium text-primary"
                                *ngIf="!item.isExternal"
                                [routerLink]="item.path | localize">
                                {{ item.label | translate }}
                            </a>

                            <a class="font-medium text-primary" *ngIf="item.isExternal" [href]="item.path | translate">
                                {{ item.label | translate }}
                            </a>
                            <p
                                class="hu-dark:text-contrast-yellow text-primary-header mt-1 text-sm"
                                *ngIf="item.description">
                                {{ item.description | translate }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Menu 3 -->
            <div class="dropdown-section flex flex-col items-center" *ngSwitchCase="'list'">
                <h3 class="hu-dark:text-contrast-yellow text-primary-header mb-3 text-center" *ngIf="menuData.title">
                    {{ menuData.title | translate | uppercase }}
                </h3>
                <div class="space-y-2">
                    <div class="dropdown-item text-left" *ngFor="let item of menuData.items">
                        <a
                            class="block py-1 text-sm font-medium text-primary"
                            *ngIf="!item.isExternal"
                            [routerLink]="item.path | localize">
                            {{ item.label | translate }}
                        </a>

                        <a
                            class="block py-1 text-sm font-medium text-primary"
                            *ngIf="item.isExternal"
                            [href]="item.path | translate">
                            {{ item.label | translate }}
                        </a>
                    </div>
                </div>
            </div>

            <!-- Menu 4 -->
            <div *ngSwitchCase="'mixed'">
                <div class="grid grid-cols-2 gap-8">
                    <div class="dropdown-section" *ngFor="let section of menuData.sections">
                        <h3 class="hu-dark:text-contrast-yellow text-primary-header mb-3">
                            {{ section.title | translate | uppercase }}
                        </h3>
                        <div class="space-y-2">
                            <div class="dropdown-item" *ngFor="let item of section.items">
                                <a
                                    class="block py-1 font-medium text-primary"
                                    *ngIf="!item.isExternal"
                                    [routerLink]="item.path | localize">
                                    {{ item.label | translate }}
                                </a>

                                <a
                                    class="block py-1 font-medium text-primary"
                                    *ngIf="item.isExternal"
                                    [href]="item.path | translate">
                                    {{ item.label | translate }}
                                </a>
                                <p
                                    class="hu-dark:text-contrast-yellow text-primary-header mt-1 text-sm"
                                    *ngIf="item.description">
                                    {{ item.description | translate }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
